import { render } from "./index.vue?vue&type=template&id=64687d6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=64687d6a&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64687d6a"],['__file',"vendor/vvg/forum/resources/vue/profile/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64687d6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64687d6a', __exports__)) {
    console.log('reload')
    api.reload('64687d6a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=64687d6a&scoped=true", () => {
    console.log('re-render')
    api.rerender('64687d6a', render)
  })

}


export default __exports__